import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/common/components/Button/Button';
import { Icon } from '@/common/components/Icons/Icon';
import { TMarket } from '@/common/constants/markets';
import { LanguageType } from '@/common/types/general';
import { getLanguagesForMarket } from './LanguageSwitcher.utils';

export function LanguageSwitcher({ market }: { market?: TMarket }) {
  const { t, i18n } = useTranslation();
  const languages = getLanguagesForMarket(market);
  const [language, setLanguage] = useState<LanguageType>(
    i18n.language as LanguageType
  );

  const changeLanguage = (nextLanguage: LanguageType) => {
    setLanguage(nextLanguage);
    i18n.changeLanguage(nextLanguage);
  };

  const getNextLanguage = () => {
    const currentIdx = languages.indexOf(language);
    const nextIdx = (currentIdx + 1) % languages.length;
    return languages[nextIdx];
  };

  return (
    languages.length > 1 && (
      <Button
        variant="tertiary"
        icon={<Icon icon="language" />}
        onPress={() => changeLanguage(getNextLanguage())}
      >
        {t(`dashboard.settings.language.${getNextLanguage()}`)}
      </Button>
    )
  );
}
